import React, { useState, useEffect } from "react";
import { CSSTransition } from "react-transition-group"; // Importer CSSTransition
import { useLocation } from "react-router-dom";
import "./App.css";
import Header from "./Components/Header/Header";
import FooterHome from "./Components/FooterHome/FooterHome";
import ScratchZone from "./Components/ScratchZone/ScratchZone";
import EntranceForms from "./Components/EntranceForms/EntranceForms";
import Winner from "./Components/Winner/Winner";
import Looser from "./Components/Looser/Looser";
import * as apiCall from "./api/apiCall";

function App() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const event = searchParams.get("event");

  const [config, setConfig] = useState(null);
  const [formSubmit, setFormSubmit] = useState(false);
  const [show, setShow] = useState(false);
  const [gain, setGain] = useState({});
  const [win, setWin] = useState(false);
  const [email, setEmail] = useState("");

  async function postUser(
    firstname,
    lastname,
    address,
    phone,
    email,
    birthDate,
    postalCode,
    code,
    optin,
    idGain,
    idConfig
  ) {
    try {
      let data = await apiCall.postUser(
        firstname,
        lastname,
        address,
        phone,
        email,
        birthDate,
        postalCode,
        code,
        optin,
        idGain,
        idConfig
      );
    } catch (error) {
      console.error("Error posting user:", error);
    }
  }

  useEffect(() => {
    async function getConfig() {
      try {
        let data = await apiCall.getConfig(event);
        setConfig(data);
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    }
    getConfig();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [show, formSubmit]);

  return (
    <div
      className="App"
      style={{ backgroundColor: config ? config.primaryColor : "#000" }}
    >
      <CSSTransition in={!show} timeout={500} classNames="fade" unmountOnExit>
        <>
          <Header config={config} />
          {config && (
            <div className="playerZone">
              <ScratchZone
                config={{
                  textWin: gain ? gain.gainsName : "GAGNÉ",
                  textLoose: "PERDU",
                }}
                setShow={setShow}
                loading={false}
                win={win}
              />
            </div>
          )}

          {config ? config.backgroundImg ? <FooterHome /> : null : null}
        </>
      </CSSTransition>

      <CSSTransition in={show} timeout={500} classNames="fade" unmountOnExit>
        <div>
          {win ? (
            <Winner gain={gain} email={email} config={config} />
          ) : (
            <Looser config={config} />
          )}
        </div>
      </CSSTransition>

      {!formSubmit && config && (
        <div className="entranceForm">
          <EntranceForms
            setFormSubmit={setFormSubmit}
            postUser={postUser}
            config={config}
            setGain={setGain}
            setWin={setWin}
            setEmail={setEmail}
          />
        </div>
      )}
      {/* <a
        href="https://luckysit.com"
        target="_blank"
        className="cgu"
        style={{ color: config ? config.secondaryColor : "#000" }}
      >
        Accès CGU
      </a> */}
    </div>
  );
}

export default App;
